import React, { useContext, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import {
  GetTransformTicketResult,
  GetTransformTicketVar,
} from "./queries/types";
import { GetTransformTicket } from "./queries/queries";
import { AppContext } from "../../../../context/context";
import { convertToTimeZone } from "../../../../utils/UtilFunctions";
import { TimeZone } from "../../../../utils/Enum.types";
import { payloadTypes } from "../../../../context/reducer";
import { TicketStatus } from "../../../../utils/constants";
import useServerDateandTimeWithoutToken from "../../../../customHooks/useServerDateandTimeWithoutToken";

interface Props {
  setTicketStatus: React.Dispatch<React.SetStateAction<TicketStatus>>;
}

const ParticularTicketDetails = ({ setTicketStatus }: Props) => {
  const {
    serverDate,
    data: serverData,
    loading: serverLoading,
  } = useServerDateandTimeWithoutToken();
  const { state, dispatch } = useContext(AppContext);
  const [getTransformTicket, { data, loading }] = useLazyQuery<
    GetTransformTicketResult,
    GetTransformTicketVar
  >(GetTransformTicket);

  useEffect(() => {
    if (state.junctionID) {
      getTransformTicket({
        variables: {
          junctionID: state.junctionID,
          ticketID: 0,
        },
      }).then(({ data }) => {
        if (data && data.GetTransformTicket) {
          dispatch({
            type: payloadTypes.SET_TICKET,
            payload: {
              ticketId: data.GetTransformTicket.id,
            },
          });
          dispatch({
            type: payloadTypes.SET_COMPANY_ID,
            payload: {
              companyId: data.GetTransformTicket.companyID,
            },
          });
          setTicketStatus(data.GetTransformTicket.status);
        }
      });
    }
  }, [getTransformTicket, state.junctionID, state.ticketId]);

  const getAging = (date: string) => {
    if (serverData && !serverLoading) {
      const presentDate = new Date(serverDate);
      const ticketDate = new Date(date);

      const diffMs = Math.abs(ticketDate.getTime() - presentDate.getTime()); // Absolute difference in ms

      const diffSec = Math.floor(diffMs / 1000); // Total seconds
      const diffMin = Math.floor(diffSec / 60); // Total minutes
      const diffHours = Math.floor(diffMin / 60); // Total hours
      const diffDays = Math.floor(diffHours / 24); // Total days

      const remainingHours = diffHours % 24; // Hours excluding full days
      const remainingMinutes = diffMin % 60; // Minutes excluding full hours
      const remainingSeconds = diffSec % 60; // Seconds excluding full minutes

      let result = "";
      if (diffDays) result += `${diffDays} days `;
      if (remainingHours) result += `${remainingHours} hrs `;
      if (remainingMinutes) result += `${remainingMinutes} mins `;
      if (remainingSeconds) result += `${remainingSeconds} secs`;

      return result.trim(); // Remove extra spaces
    }
    return "";
  };

  return (
    <div className="mobile-tkt-details--particular-tkt">
      {data && data.GetTransformTicket ? (
        <ul>
          <li>
            <span>Ticket No.</span> <span>:</span>
            <b>{data.GetTransformTicket.ticketNo}</b>
          </li>
          <li>
            <span>Ticket Date</span> <span>:</span>
            <div className="d-flex gap-2">
              <b>
                {
                  convertToTimeZone(
                    TimeZone.Asia_Kolkata,
                    data.GetTransformTicket.ticketDate
                  ).date
                }
              </b>
              <span className="font-grey">
                {
                  convertToTimeZone(
                    TimeZone.Asia_Kolkata,
                    data.GetTransformTicket.ticketDate
                  ).time
                }
              </span>
            </div>
          </li>
          <li>
            <span>Junction Code.</span> <span>:</span>
            <b>{data.GetTransformTicket.junction.code}</b>
          </li>
          <li>
            <span>Junction Name</span> <span>:</span>
            <b>{data.GetTransformTicket.junction.name}</b>
          </li>
          <li>
            <span>Junction alias</span> <span>:</span>
            <b>{data.GetTransformTicket.junction.alias}</b>
          </li>
          <li>
            <span>Maintained By</span> <span>:</span>
            <b>{data.GetTransformTicket.vendorDetails.desc}</b>
          </li>
          <li>
            <span>Ticket Raised By</span> <span>:</span>
            <b>
              {data.GetTransformTicket.ticketDetails[0].createdUserDetails.name}
            </b>
          </li>
          <li>
            <span>Priority</span> <span>:</span>
            <b>{data.GetTransformTicket.priority}</b>
          </li>
          <li>
            <span>Ticket Status</span> <span>:</span>
            <b>{data.GetTransformTicket.status}</b>
          </li>
          {/* <li>
            <span>Photo</span> <span>:</span>
            <b>{data.GetTransformTicket.ticketDetails[0].imagesPath}</b>
          </li> */}
          <li>
            <span>Remarks</span> <span>:</span>
            <b>{data.GetTransformTicket.openRemarks}</b>
          </li>
          <li>
            <span>Ageing</span> <span>:</span>
            <b>{getAging(data.GetTransformTicket.ticketDate)}</b>
          </li>
          <li>
            <span>Assigned To</span> <span>:</span>
            <b>{data.GetTransformTicket.assignedUser.name}</b>
          </li>
        </ul>
      ) : null}
    </div>
  );
};

export default ParticularTicketDetails;
